module.exports = __webpack_public_path__ + "img/logoRainbow.9fc79ccc.svg";